










































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import * as firebase from "firebase/app";
import "firebase/auth";

@Component
export default class App extends Vue{
  name = "App";
  dark = false;
  group = null;
  drawer = false;
  
  mounted() {
    if (localStorage.dark !== undefined) {
      this.dark = JSON.parse(localStorage.dark);
    }
  }
  
  get email(): string {
    return this.$store.state.user?.email ?? "";
  }
  
  get userDataFetched(): boolean {
    return this.$store.state.user;
  }
  
  get isLoggedIn(): boolean {
    const user = this.$store.state.user;
    return user && user.isLoggedIn;
  }

  logout() {
    firebase.auth().signOut();
  }

  @Watch("dark")
  onDarkChanged(value: boolean) {
    this.$vuetify.theme.dark = value;
    localStorage.dark = value;
  }
}
